import logo from './logo.svg';
import './Clicker.css';
import React, { useRef, useState } from 'react';

export default function Clicker() {
  
  const startAnimationDuration = 10;    // początkowy czas trwania animacji
  const finishAnimationDuration = 0.3;    // końcowy czas trwania animacji
  
  const [animationDuration, setAnimationDuration] = useState(startAnimationDuration); // bieżący czas trwania animacji
  const [velocity, setVelocity] = useState(-0.1); // przyspieszenie (na poczatku ujemne, gdyż skaracamy czas trwania animacji)
  const [velocityInfo, setVelocityInfo] = useState("skracamy"); // komunikat zmiany kierunku predkości

  const divRef = useRef(null);  //referencja do DOM element div (zmiana koloru tła)
  const logoRef = useRef(null); //referencja do DOM element logo (obrót zdjęcia)
  const [change, setChange] = useState(false);  // zmienna stanu - flaga zmiany koloru

  // zmiana koloru tła
  const changeColor = () => {
    if (divRef.current) { // jeśli ref jest przypisany
      if (change) {
        divRef.current.style.backgroundColor = "rgb(87, 106, 246)";
        setChange(false);
      } else {
        divRef.current.style.backgroundColor = "rgb(199, 252, 206)";
        setChange(true);
      }
      increaseAnimationSpeed();    // zwiekszenie szybkosci obrotu
    }
  };

  // Funkcja do przyspieszania animacji (zmniejsza czas animacji o 0.1 sek aż do 0.3 sek)
  function increaseAnimationSpeed() {
    setAnimationDuration(prevDuration => {
      const newDuration = Math.max(prevDuration + velocity, finishAnimationDuration); // Przyspiesza animację o 0.1 sekundy
      if (newDuration <= finishAnimationDuration){                // zmiana velocity
        setVelocity(0.1);
        setVelocityInfo("wydłużamy");
      }else if(newDuration >= startAnimationDuration){
        setVelocity(-0.1);
        setVelocityInfo("skracamy");
      }
      if (logoRef.current) {   // czy ref istnieje
        logoRef.current.style.animationDuration = `${newDuration}s`; // Ustaw nowy czas trwania animacji
      }
      return newDuration;
    });
  }

  return (
    <div className="clicker" ref={divRef}>
      <p style={{padding: '10px'}}>czas animacji {velocityInfo} o 0.1 sekundy po każdym kliknięciu <br />{animationDuration}s<br />WTF!!! </p>
      <button onClick={changeColor}>Change spin</button>
      <h1>clicker</h1>
      <img src={logo} ref={logoRef} className="clicker-logo" alt="logo" />
    </div>
  );
}

